// extracted by mini-css-extract-plugin
export default {"introduction":"PicPage_introduction__g57Lz"};